<template lang="html">
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-form @submit.prevent="submit()">
        <d-form-row>
          <!-- Receipt Message -->
          <d-col md="12" class="form-group">
            <d-tabs>
              <d-tab :title="item.name" class="p-3" v-for="(item, index) in model.quotationClass" :key="index">
                <d-form-row class="align-items-center">
                  <d-col md="3" class="form-group">
                    <label>Nome</label>
                    <d-form-input type="text" v-model="item.name"/>
                  </d-col>
                  <d-col md="3" class="form-group">
                    <label>Duração</label>
                    <d-form-input type="text" v-model="item.duration"/>
                  </d-col>
                  <d-col md="6" class="form-group">
                    <label>Finalidade</label>
                    <d-form-input type="text" v-model="item.purpose"/>
                  </d-col>
                  <d-col md="3" class="form-group">
                    <label>Detex</label>
                    <d-form-input type="text" v-model="item.detex"/>
                  </d-col>
                </d-form-row>
                <d-form-row class="border mb-3">
                  <table class="table mb-0 table-striped">
                    <thead class="bg-light">
                      <tr>
                        <th colspan="6">
                          <h6 class="mb-0">Lista de gramas</h6>
                        </th>
                      </tr>
                      <tr>
                        <th scope="col" class="border-0">#</th>
                        <th scope="col" class="border-0">MM</th>
                        <th scope="col" class="border-0">Preço borracha</th>
                        <th scope="col" class="border-0">Preço orgânico</th>
                        <th scope="col" class="border-0">Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, id) in item.pricing" :key="id">
                        <td>
                          <span>{{ id + 1 }}</span>
                        </td>
                        <td>
                          <d-input type="number" v-model="row.mm" placeholder="0mm" />
                        </td>
                        <td>
                          <d-input-group prepend="R$">
                            <input-currency
                              model-index="rubberPrice"
                              placeholder="R$ 0,00"
                              :model="row"
                            ></input-currency>
                          </d-input-group>
                        </td>
                        <td>
                          <d-input-group prepend="R$">
                            <input-currency
                              model-index="organicPrice"
                              placeholder="R$ 0,00"
                              :model="row"
                            ></input-currency>
                          </d-input-group>
                        </td>
                        <td cols class="text-right text-semibold">
                          <i class="fas fa-plus text-success" @click="addRow(item)" v-if="id + 1 == item.pricing.length"></i>
                          <i class="fas fa-minus text-danger ml-2" @click="removeRow(item, id)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </d-form-row>
              </d-tab>
            </d-tabs>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-button type="submit" class="btn-primary">Salvar</d-button>
        </d-form-row>
      </d-form>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import CurrencyMask from '_common/mixins/CurrencyMask';
import InputCurrency from '_shared/InputCurrency.vue';
import SettingsService from '_services/rest/modules/settings';
import Events from '_utils/events';
import { CLASSES, PRICES, _LOAD_MODEL_SETTING_ } from './SettingsModel';

export default {
  name: 'classes-form',
  mixins: [CurrencyMask],
  components: {
    InputCurrency,
  },
  data() {
    return {
      model: { ...CLASSES },
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    addRow(item) {
      item.pricing.push({ ...PRICES });
    },
    checkEmpty(item) {
      if (item.pricing.length === 0) {
        item.pricing.push({ ...PRICES });
      }
    },
    removeRow(item, index) {
      item.pricing.splice(index, 1);
      this.checkEmpty(item);
    },
    removeEmptyRow() {
      if (this.model.quotationClass) {
        this.model.quotationClass.forEach(showClass => {
          showClass.pricing = showClass.pricing.filter(price => price.mm !== 0);
        });
      }
    },
    submit() {
      this.removeEmptyRow();
      SettingsService.saveOptions(this.model, 'settings')
        .then(() => this.activeAlert({ message: 'Classe salva com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...CLASSES, ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
